// extracted by mini-css-extract-plugin
module.exports = {"Select":"StatusList_Select__2M6DB","select":"StatusList_Select__2M6DB"};